import { style } from "@vanilla-extract/css";

export const elementPhotoStyles = style({
  display: "inline-block",
  maxWidth: "100%",
  verticalAlign: "middle",
});
